import { PlusOutlined } from "@ant-design/icons"
import { Button } from "antd"
import { Suspense, lazy, useState } from "react"

import type { ProjectTypeFormData } from "../../../../../types/project.types.ts"

const ProjectViewAddProjectTypeModal = lazy(() =>
  import("./ProjectViewAddProjectTypeModal.tsx").then((m) => ({
    default: m.ProjectViewAddProjectTypeModal
  }))
)

interface ProjectViewAddProjectTypeModalProps {
  onAddProjectType: (data: ProjectTypeFormData) => Promise<void>
}

export function ProjectViewAddProjectTypeController({
  onAddProjectType
}: ProjectViewAddProjectTypeModalProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        className={"ml-2"}
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => setOpen(true)}
      >
        Project
      </Button>

      <Suspense fallback={null}>
        {open && (
          <ProjectViewAddProjectTypeModal
            open={open}
            onClose={() => setOpen(false)}
            onSubmit={onAddProjectType}
          />
        )}
      </Suspense>
    </>
  )
}
